export const selectPublicConfig = (state) => state.publicConfig;
